import { SavedSearchModel, UserModel } from '../../models';
import { Observable } from 'rxjs';

export abstract class BaseSavedSearchService {
  public abstract getSavedSearches(): Observable<SavedSearchModel[]>;

  public abstract deleteSavedSearch(uuid: string, savedSearch: SavedSearchModel[]): Observable<SavedSearchModel[]>;

  public abstract upsertSavedSearches(savedSearch: SavedSearchModel, user: UserModel): Observable<SavedSearchModel[]>;
}
